import React from 'react';
import { useTranslation } from 'react-i18next';
import './DailySlaWidget.css';

const DailySlaWidget = ({ data, config }) => {
    const { t } = useTranslation();

    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    const fmt = (val) => {
        if (val === null || val === undefined) return '-';
        return Number(val).toLocaleString();
    };

    const fmtPct = (val) => {
        if (val === null || val === undefined) return '-';
        const n = Number(val);
        return `${n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)}%`;
    };

    return (
        <div className="daily-sla-widget">
            <div className="daily-sla-table-container">
                <table className="daily-sla-table">
                    <thead>
                        {/* Row 1: main column groups */}
                        <tr>
                            <th rowSpan={2} className="col-day">{t('DAY')}</th>
                            <th rowSpan={2} className="col-served">{t('SERVED_CALLS')}</th>
                            <th rowSpan={2} className="col-redirected">{t('REDIRECTED_CALLS')}</th>
                            <th colSpan={8} className="group-header">{t('SERVED_CALLS_STATISTICS')}</th>
                        </tr>
                        {/* Row 2: sub-columns */}
                        <tr>
                            <th className="col-bucket">{t('SECONDS_0_15')}</th>
                            <th className="col-pct">{t('PCT_SERVED_LT_15')}</th>
                            <th className="col-bucket">{t('SECONDS_15_30')}</th>
                            <th className="col-pct">{t('PCT_SERVED_LT_30')}</th>
                            <th className="col-bucket">{t('SECONDS_30_45')}</th>
                            <th className="col-pct">{t('PCT_SERVED_LT_45')}</th>
                            <th className="col-bucket">{t('SECONDS_45_60')}</th>
                            <th className="col-pct">{t('PCT_SERVED_LT_60')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, idx) => (
                            <tr key={idx}>
                                <td className="col-day">{row.day ?? '-'}</td>
                                <td className="col-number">{fmt(row.servedCalls)}</td>
                                <td className="col-number">{fmt(row.redirectedCalls)}</td>
                                <td className="col-number">{fmt(row.count_0_15)}</td>
                                <td className="col-pct-val">{fmtPct(row.pct_lt_15)}</td>
                                <td className="col-number">{fmt(row.count_15_30)}</td>
                                <td className="col-pct-val">{fmtPct(row.pct_lt_30)}</td>
                                <td className="col-number">{fmt(row.count_30_45)}</td>
                                <td className="col-pct-val">{fmtPct(row.pct_lt_45)}</td>
                                <td className="col-number">{fmt(row.count_45_60)}</td>
                                <td className="col-pct-val">{fmtPct(row.pct_lt_60)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DailySlaWidget;
